export enum ProductType {
	Goods = 'Goods',
	Service = 'Service',
	Licence = 'Licence',
}

export enum ProductState {
  Active = 'Active',
  Removed = 'Removed',
  Hidden = 'Hidden',
}

export type Product = {
	cost: number
	name: string
	description: string
	id: number
	image: string | null
	type: ProductType
	currency: string
  state: ProductState
}

export type EditProductModel = Omit<Product, 'state'>

export type CreateProductModel = Omit<Product, 'state'|'id'>
